'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector read only field
 *
 * @class
 */

class InspectorImage extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': '',
                'value': '',
                'tooltip': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__inspector__item">
                <% if(title) { %> 
                    <div class="editor__inspector__item__label"><%- title %></div> 
                <% } %>
                <img class='editor__inspector__item__image' title="<%= tooltip %>" src="<%= value %>"/>
            </div>
        `;

        super.render();

        $('.editor__inspector__item__image', this.$el).on('click', this._clicked);
    }

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:Inspector:click', e);
    }

    select(){
        $('.editor__inspector__item__image', this.$el).addClass('editor__inspector__item__image--active');
    }

    deselect(){
        $('.editor__inspector__item__image', this.$el).removeClass('editor__inspector__item__image--active');
    }
}

module.exports = InspectorImage;